import api from './api';

const extractData = (data) => {
  if (data && typeof data === 'object' && data.$values) {
    return data.$values;
  }
  return data;
};

const placeServiceProfessionalsService = {
  // Retorna todos os profissionais vinculados a um serviço do local
  // GET /api/places/{placeId}/services/{serviceId}/professionals
  getByPlaceServiceId: async (placeId, serviceId) => {
    const response = await api.get(`/places/${placeId}/services/${serviceId}/professionals`);
    return extractData(response.data);
  },

  // Retorna os profissionais disponíveis para adicionar ao serviço
  // GET /api/places/{placeId}/services/{serviceId}/professionals/available
  getAvailableForService: async (placeId, serviceId) => {
    const response = await api.get(`/places/${placeId}/services/${serviceId}/professionals/available`);
    return extractData(response.data);
  },

  // Buscar por ID
  // GET /api/places/{placeId}/services/{serviceId}/professionals/{id}
  getById: async (placeId, serviceId, id) => {
    const response = await api.get(`/places/${placeId}/services/${serviceId}/professionals/${id}`);
    return extractData(response.data);
  },

  // Adicionar profissional ao serviço do local
  // POST /api/places/{placeId}/services/{serviceId}/professionals
  // Body: { placeProfessionalId }
  create: async (placeId, serviceId, data) => {
    const response = await api.post(`/places/${placeId}/services/${serviceId}/professionals`, data);
    return extractData(response.data);
  },

  // Atualizar vínculo (reservado para futuras customizações)
  // PUT /api/places/{placeId}/services/{serviceId}/professionals/{id}
  update: async (placeId, serviceId, id, data) => {
    const response = await api.put(`/places/${placeId}/services/${serviceId}/professionals/${id}`, data);
    return extractData(response.data);
  },

  // Remover profissional do serviço
  // DELETE /api/places/{placeId}/services/{serviceId}/professionals/{id}
  delete: async (placeId, serviceId, id) => {
    const response = await api.delete(`/places/${placeId}/services/${serviceId}/professionals/${id}`);
    return response.data;
  },

  // Helper: Deletar por serviceId + professionalId (busca a lista primeiro para pegar o ID)
  deleteByServiceAndProfessional: async (placeId, serviceId, professionalId) => {
    // Primeiro buscar a lista de profissionais vinculados ao serviço
    const professionals = await placeServiceProfessionalsService.getByPlaceServiceId(placeId, serviceId);
    
    // Encontrar o vínculo específico
    const link = professionals.find(p => p.professionalId === professionalId);
    
    if (!link) {
      throw new Error('Vínculo não encontrado');
    }
    
    // Deletar usando o ID do vínculo
    return placeServiceProfessionalsService.delete(placeId, serviceId, link.id);
  },
};

export default placeServiceProfessionalsService;
